import React from 'react';
import { ErrorPage } from '../../components/common/page/ErrorPage';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';

export const ServiceUnavailablePage = () => {
    useDocumentTitle('Service Unavailable');
    return (
        <ErrorPage
            code="503"
            title="Service Unavailable"
            description="The server is temporary unable to service your request due to maintenance downtime
        or capacity problems.<br/> Please try again later.">
            <div className="service-unavailable-icon text-center">
                <span className="fa-5x fa-stack mb-3">
                    <i className="fas fa-square fa-stack-2x text-primary"></i>
                    <i
                        className="fas fa-times fa-stack-1x fa-inverse"
                        data-fa-transform="shrink-6 left-7"></i>
                    <i
                        className="fas fa-times fa-stack-1x fa-inverse"
                        data-fa-transform="shrink-6 right-7 "></i>
                    <i
                        className="fas fa-minus fa-stack-1x fa-inverse"
                        data-fa-transform="shrink-5 down-7"></i>
                    <i
                        className="fas fa-snooze fa-stack-1x text-muted"
                        data-fa-transform="shrink-5 right-15 up-15"></i>
                    <i
                        className="fas fa-cog fa-stack-1x text-muted"
                        data-fa-transform="shrink-5 left-15 up-15"></i>
                    <i
                        className="fas fa-cog fa-stack-1x text-muted"
                        data-fa-transform="shrink-5 right-14 down-14"></i>
                </span>
            </div>
        </ErrorPage>
    );
};
